import ServiceForm from "../component/ServiceForm";

const ServiceEdit = () => {
  return <ServiceForm isEditMode={true} />;
};

export default ServiceEdit;
